<script>
  import { phoneWidth } from '../stores.js';
  import { onMount } from 'svelte';
  export let idKor = 'idkor';
  export let idEn = 'idEn';
  export let descMain = ['descMain1', 'descMain2'];
  export let descSub = ['descSub1', 'descSub2'];

  const slideInOffset = 150;
  let descMainMarginLeft = 0;
  let innerHeight, innerWidth;
  $: isPhoneSize = innerWidth <= phoneWidth;

  let wrapper;
  let target1, target2, target3, target4;

  function sectionAnim() {
    const targets = [target1, target2, target3, target4];
    const boxTop = wrapper.getBoundingClientRect().top;

    if (boxTop < innerHeight * 0.65) {
      targets.forEach((target) => target.classList.add('active'));
    } else {
      targets.forEach((target) => target.classList.remove('active'));
    }
  }
  onMount(() => {
    window.addEventListener('scroll', sectionAnim);
  });
</script>

<svelte:window bind:innerHeight bind:innerWidth />

<div class="container desc" bind:this={wrapper}>
  <div class="id-wrapper">
    <span class="id-kor">{idKor}</span>
    <span class="id-en">{idEn}</span>
  </div>
  <div class="desc-main-wrapper">
    {#if isPhoneSize}
      <div class="desc-main anim-phone main" bind:this={target1}>
        {descMain[0]}
      </div>
      <div class="desc-main anim-phone main" bind:this={target2}>
        {descMain[1]}
      </div>
    {:else}
      <div class="desc-main anim-pc main" bind:this={target1}>
        {descMain[0]}
      </div>
      <div class="desc-main anim-pc main" bind:this={target2}>
        {descMain[1]}
      </div>
    {/if}
  </div>
  <div class="desc-sub-wrapper">
    <div class="desc-sub anim-sub" bind:this={target3}>{descSub[0]}</div>
    <div class="desc-sub anim-sub" bind:this={target4}>{descSub[1]}</div>
  </div>
</div>
<div class="css-keeper anim-phone anim-sub anim-pc main sub active" />

<style>
  .css-keeper {
    display: none;
  }
  .container.desc {
    width: 100%;
  }
  .id-wrapper {
    color: #666;
    margin-bottom: 50px;
  }
  .id-wrapper span {
    display: inline-block;
  }
  .id-kor {
    font-weight: 500;
    font-size: 36px;
  }
  .id-en {
    font-weight: 100;
    font-size: 18px;
  }

  .desc-main-wrapper {
    font-weight: 500;
    font-size: 80px;
    margin-bottom: 50px;
  }
  .desc-main {
    margin: 0;
  }

  .desc-sub-wrapper {
    font-weight: 200;
    font-size: 28px;
  }
  .desc-sub {
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    .id-kor {
      font-size: 24px;
    }
    .id-en {
      font-size: 15px;
    }

    .desc-main-wrapper {
      font-weight: 600;
      font-size: 32px;
      text-align: center;
    }

    .desc-main:first-child {
      /* font-size: 40px; */
      font-size: 13vw;
      margin-bottom: 5px;
    }
    .desc-main:nth-child(2) {
      font-weight: 500;
      font-size: 8vw;
      margin-bottom: 18px;
    }

    .desc-sub-wrapper {
      font-size: 20px;
      text-align: center;
      word-break: keep-all;
    }
    .desc-sub {
      display: inline;
    }
    .desc-sub::before {
      content: ' ';
    }

    .anim-phone {
      transition: 0.5s;
      opacity: 0;
      transform: translateY(50px);
    }
    .anim-phone.active {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .anim-pc {
    transition: 0.5s;
    opacity: 0;
    transform: translateX(100px);
  }
  .anim-pc.active {
    opacity: 1;
    transform: translateY(0px);
  }
  .anim-sub {
    transition: 1.5s;
    opacity: 0;
  }
  .anim-sub.active {
    opacity: 1;
  }
</style>
